import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import 'swiper/swiper.min.css';
import classnames from 'classnames';
import { get } from 'lodash-es';
import { useMemo } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Image, VideoControl } from '../../common/components';
import { useMobile } from '../../common/hooks/use-mobile';
import { isClickable, transformInterval, transformPageMargins } from '../../common/utils';
import { Navigation } from './navigation';
import { useDesignContext } from '../../design-provider';
export var Nav = function Nav(props) {
  var mode = props.mode,
    picNavList = props.picNavList,
    textNavList = props.textNavList,
    _props$lineDisplay = props.lineDisplay,
    lineDisplay = _props$lineDisplay === void 0 ? '4' : _props$lineDisplay,
    _props$textPosition = props.textPosition,
    textPosition = _props$textPosition === void 0 ? 'inPic' : _props$textPosition,
    pagePadding = props.pagePadding,
    imageSpacing = props.imageSpacing,
    arrowType = props.arrowType;
  var isMobile = useMobile();
  var _useDesignContext = useDesignContext(),
    designOnLink = _useDesignContext.designOnLink;
  var lineDisplayFormat = useMemo(function () {
    if (lineDisplay === '8' && isMobile) return '4';
    if (lineDisplay === '10' && isMobile) return '5';
    return lineDisplay;
  }, [lineDisplay, isMobile]);
  var graphicalNavList = mode === 'picNav' ? picNavList : textNavList;
  var navigation = graphicalNavList.length > Number(lineDisplayFormat) && props.picStyle === 'scroll';
  var warpStyle = function warpStyle() {
    var styles = {};
    if (props.bgSetting === 'color') {
      styles.backgroundColor = props.bgColor;
    }
    if (props.bgSetting === 'pic') {
      styles.backgroundImage = "url(".concat(get(props.bgImage, 'path'), ")");
      styles.backgroundSize = '200px 200px';
      styles.backgroundRepeat = 'repeat';
    }
    return styles;
  };
  function renderPicItem(item) {
    return _jsx("a", Object.assign({
      className: classnames('block w-full h-full', {
        'cursor-pointer': isClickable(item.target)
      }),
      href: designOnLink(item.target)
    }, {
      children: _jsxs("div", Object.assign({
        className: 'relative flex flex-col w-full h-full overflow-hidden'
      }, {
        children: [_jsxs("div", Object.assign({
          className: classnames('flex-1 w-full flex items-center justify-center', textPosition === 'inPic' ? 'h-full' : 'h-auto')
        }, {
          children: [item.fileType === 'image' && _jsx(Image, {
            className: classnames('w-full h-full', {
              'cursor-pointer': isClickable(item.target)
            }),
            src: item.fileValue
          }), item.fileType === 'video' && _jsx(VideoControl, {
            videoClassName: 'w-full h-full',
            playBtnClassName: classnames('right-2 bottom-2', 'cq-pc:w-16 cq-pc:h-16', 'cq-mobile:w-4 cq-mobile:h-4'),
            coverImage: item.coverImage,
            fileValue: item.fileValue
          })]
        })), _jsx("div", Object.assign({
          className: classnames('flex-shrink-0 flex justify-center items-start w-full mt-3 text-center', 'cq-pc:text-sm cq-pc:px-2.5 cq-pc:h-10', 'cq-mobile:text-xs cq-mobile:px-1', {
            'absolute left-0 bottom-1': textPosition === 'inPic'
          }),
          style: {
            color: props.color
          }
        }, {
          children: _jsx("span", Object.assign({
            className: classnames('cq-mobile:line-clamp-1', 'cq-pc:line-clamp-2')
          }, {
            children: item.title
          }))
        }))]
      }), item.id)
    }));
  }
  function renderTextItem(item) {
    return _jsx("a", Object.assign({
      className: classnames('flex justify-center items-center', 'cq-pc:text-sm', 'cq-mobile:text-xs', 'block', {
        'cursor-pointer': isClickable(item.target)
      }),
      style: {
        color: props.color
      },
      href: designOnLink(item.target)
    }, {
      children: _jsx("span", Object.assign({
        className: classnames('line-clamp-2')
      }, {
        children: item.title
      }))
    }), item.id);
  }
  function renderItem(item) {
    return mode === 'picNav' ? renderPicItem(item) : renderTextItem(item);
  }
  if (props.picStyle === 'default') {
    return _jsx("div", Object.assign({
      className: 'w-full',
      style: warpStyle()
    }, {
      children: _jsx("div", Object.assign({
        className: mode === 'picNav' ? 'container' : 'w-full'
      }, {
        children: _jsx("div", Object.assign({
          className: classnames('box-border grid mx-auto w-full', {
            'grid-cols-4': lineDisplayFormat === '4',
            'grid-cols-5': lineDisplayFormat === '5',
            'grid-cols-8': lineDisplayFormat === '8',
            'grid-cols-10': lineDisplayFormat === '10'
          }),
          style: {
            padding: "0 ".concat(transformPageMargins(pagePadding, isMobile)),
            gap: transformInterval(imageSpacing, isMobile, 'photoAds')
          }
        }, {
          children: graphicalNavList.map(renderItem)
        }))
      }))
    }));
  }
  return _jsx("div", Object.assign({
    className: 'w-full',
    style: warpStyle()
  }, {
    children: _jsx("div", Object.assign({
      className: mode === 'picNav' ? 'container' : 'w-full'
    }, {
      children: _jsx("div", Object.assign({
        className: 'box-border overflow-hidden w-full',
        style: {
          padding: "0 ".concat(transformPageMargins(pagePadding, isMobile))
        }
      }, {
        children: _jsx(Navigation, Object.assign({
          arrow: arrowType === 'visible' ? 'show' : arrowType === 'hover' ? 'hover' : undefined,
          navigation: navigation
        }, {
          children: _jsx(Swiper, Object.assign({
            observer: true,
            observeParents: true,
            observeSlideChildren: true,
            resizeObserver: true,
            allowTouchMove: navigation,
            loop: navigation,
            centeredSlides: false,
            slidesPerView: Number(lineDisplayFormat),
            spaceBetween: transformInterval(imageSpacing, isMobile, 'photoAds', false)
          }, {
            children: graphicalNavList.map(function (item) {
              return _jsx(SwiperSlide, Object.assign({
                className: 'h-auto',
                style: {
                  width: mode === 'textNav' ? "".concat(Math.floor(1 / Number(lineDisplayFormat) * 100), "%") : undefined
                }
              }, {
                children: renderItem(item)
              }), item.id);
            })
          }), graphicalNavList.map(function (i) {
            return i.id;
          }).join(String(isMobile)))
        }))
      }))
    }))
  }));
};